<template>
  <v-dialog v-model="dummyAdvDialog" width="900">
    <AdCardOneFullImage ref="fullAdImageOne"></AdCardOneFullImage>
    <v-card>
      <!-- <pre>{{articledata}}s</pre> -->
      <v-toolbar flat>
        <v-spacer></v-spacer>
        <v-spacer></v-spacer>
        <v-btn color="error" title="Lukk vindu" class="ma-2" outlined icon large @click="closeDialog">
          <v-icon>close</v-icon>
        </v-btn>
      </v-toolbar>
      <v-card-text>
        <p class="pr-5 text--primary title pt-5 text-center">{{$t('advertisment.Get your newz out there')}}</p>
        <v-divider></v-divider>
        <v-divider></v-divider>
        <v-col md="12">
          <v-img :src="`/create.png`" width="100%" height="400px" contain @click.stop="$refs.fullAdImageOne.openDialog()"/>
        </v-col>
         <v-row class="ma-0 pa-0">
          <v-col md="12">
            <v-hover>
              <v-card text height="100%" outlined elevation="6" slot-scope="{ hover }" :class="`elevation-${hover ? 12 : 0}`">
                <v-card-text>
                  <p class="title mb-0">{{$t('advertisment.As an logged in user, you will be able to create and publish your own articles')}}</p>
                  <p class="title mb-0">{{$t('advertisment.The option of adding tags both location of the newz, aswell as #tags')}}</p>
                  <p class="title mb-0">{{$t('advertisment.Not only that! you will also have the options of: ')}}</p>
                  <p class="title mb-0 pl-3">{{$t('advertisment.Enabling or disabling comments on the article')}}</p>
                  <p class="title mb-0 pl-3">{{$t('advertisment.To publish / unpublish the article, and simply save it for later use')}}</p>
                  <p class="title pl-3">{{$t('advertisment.And to select what personal information you wish to display through settings')}}</p>
                </v-card-text>
              </v-card>
            </v-hover>
          </v-col>
        </v-row> 
      </v-card-text>
      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn color="warning" @click="closeDialog()">{{$t('general.close')}}</v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import AdCardOneFullImage from "@/components/dialogs/adCardOneFullImage.vue";
// Import the i18n - This may need to be modified
import messages from "../modules/lang/export";
export default {
  // Communicate with i18n
  i18n: { messages },
  components:{
    AdCardOneFullImage
  },
  data(){
    return{
      // Define the dialog v-model that we are using
      dummyAdvDialog:false,
      // articledata: {}
      reasons: ['Duplicate', 'Harrasment', 'Breaking ToS'],
      reportData:{
        reason:"",
        moreDetails:"",
        articleId: null,
        reportedBy: ""
      }
    }
  },
  methods: {
    // Opening the dialog through the ref
    openDialog() {
    // this.articledata = articledata;
      this.dummyAdvDialog = true;
    },
    // Close the dialog
    closeDialog() {
      this.dummyAdvDialog = false;
    }
  }
}
</script>